import app from 'flarum/forum/app';
import Modal from 'flarum/components/Modal';
import Button from 'flarum/components/Button';
import Stream from 'flarum/utils/Stream';
import avatar from 'flarum/common/helpers/avatar';
import Select from 'flarum/common/components/Select';

import AvatarEditor from 'flarum/forum/components/AvatarEditor';

import UploadComponent from '../UploadComponent';
import getStatusSetting from '../../common/util/getStatusSetting';
import addDaysToDate from '../../common/util/addDaysToDate';
import showAlert from '../../common/util/showAlert';
import UserApplyInviteCodeModal from "./UserApplyInviteCodeModal";
import getUserInfo from "../../common/util/getUserInfo";

export default class UserManageUserEditModal extends Modal {
  static isDismissibleViaBackdropClick = false;
  static isDismissibleViaCloseButton = true;

  oninit(vnode) {
    super.oninit(vnode);
    this.userInfoData = this.attrs.userInfoData;
    this.userInfoOriginalData = this.attrs.userInfoData;
    this.userEditFrom = this.attrs.userEditFrom || "user";
    this.loading = false;
    this.editMode = this.attrs.editMode || false;
    this.resetData = false;
    this.modified = true;

    this.userData = this.userInfoData.u2diUserData();
    this.userKey = this.userInfoData.userKey();
    const lxdh_wx_qr = this.userInfoData.lxdh_wx_qr() || "[]";

    this.settings = {};

    if(this.attrs.settings){
      const settings = this.attrs.settings;
      this.settings.u2di_userPassword = (settings.u2di_userPassword);
      this.settings.u2di_userAvatar = (settings.u2di_userAvatar);
      this.settings.u2di_userEmail = (settings.u2di_userEmail);
      this.settings.u2di_userSuffix = (settings.u2di_userSuffix);
      this.settings.u2di_jjType = (settings.u2di_jjType);
      this.settings.u2di_jjTypeValue = (settings.u2di_jjTypeValue);
      this.settings.u2di_userID = settings.u2di_userID;
      this.settings.u2di_userType = (settings.u2di_userType);
      this.settings.u2di_userSigned = (settings.u2di_userSigned);
      this.settings.u2di_userStatus = (settings.u2di_userStatus);
      this.settings.u2di_expireDays = (settings.u2di_expireDays);
      this.settings.u2di_noExpiration = (settings.u2di_noExpiration);
      this.settings.u2di_bmqy = (settings.u2di_bmqy);
      this.settings.u2di_zjgw = (settings.u2di_zjgw);
      this.settings.u2di_zsxm = (settings.u2di_zsxm);
      this.settings.u2di_zsxm_title = (settings.u2di_zsxm_title);
      this.settings.u2di_lxdh = (settings.u2di_lxdh);
      this.settings.u2di_lxdh_wx = (settings.u2di_lxdh_wx);
      this.settings.u2di_lxdh_wx_checked = (settings.u2di_lxdh_wx_checked);
      this.settings.u2di_lxdh_wx_qr = (settings.u2di_lxdh_wx_qr);
      this.settings.u2di_khh = (settings.u2di_khh);
      this.settings.u2di_yhkh = (settings.u2di_yhkh);
      this.settings.u2di_sfzh = (settings.u2di_sfzh);
    }else{
      this.settings.u2di_userPassword = Stream("");
      this.settings.u2di_userAvatar = Stream(this.userData.avatarUrl());
      this.settings.u2di_userEmail = Stream(this.userData.email());
      this.settings.u2di_userSuffix = Stream(this.userInfoData.userSuffix());
      this.settings.u2di_jjType = Stream(this.userInfoData.jjType());
      this.settings.u2di_jjTypeValue = Stream(this.userInfoData.jjTypeValue());
      this.settings.u2di_userID = this.userData.id();
      this.settings.u2di_userType = Stream(this.userInfoData.userType());
      this.settings.u2di_userStatus = Stream(this.userInfoData.userStatus());
      this.settings.u2di_userSigned = Stream(this.userInfoData.userSigned());
      this.settings.u2di_expireDays = Stream(this.userInfoData.expireDays());
      this.settings.u2di_noExpiration = Stream(this.userInfoData.noExpiration());
      this.settings.u2di_bmqy = Stream(this.userInfoData.bmqy());
      this.settings.u2di_zjgw = Stream(this.userInfoData.zjgw());
      this.settings.u2di_zsxm = Stream(this.userInfoData.zsxm());
      this.settings.u2di_zsxm_title = Stream(this.userInfoData.zsxm_title());
      this.settings.u2di_lxdh = Stream(CryptoJSAesJson.decrypt(this.userInfoData.lxdh(), this.userKey));
      this.settings.u2di_lxdh_wx = Stream(CryptoJSAesJson.decrypt(this.userInfoData.lxdh_wx(), this.userKey));
      this.settings.u2di_lxdh_wx_checked = Stream(this.userInfoData.lxdh()===this.userInfoData.lxdh_wx());
      this.settings.u2di_lxdh_wx_qr = Stream(JSON.parse(lxdh_wx_qr));
      this.settings.u2di_khh = Stream(CryptoJSAesJson.decrypt(this.userInfoData.khh(), this.userKey));
      this.settings.u2di_yhkh = Stream(CryptoJSAesJson.decrypt(this.userInfoData.yhkh(), this.userKey));
      this.settings.u2di_sfzh = Stream(CryptoJSAesJson.decrypt(this.userInfoData.sfzh(), this.userKey));
    }
  }

  onupdate(){
    if(this.resetData===true){
      this.resetData = false;
      this.userData = this.userInfoOriginalData.u2diUserData();
      const lxdh_wx_qr = this.userInfoOriginalData.lxdh_wx_qr() || "[]";

      this.settings.u2di_userPassword = Stream("");
      this.settings.u2di_userAvatar = Stream(this.userData.avatarUrl());
      this.settings.u2di_userEmail = Stream(this.userData.email());
      this.settings.u2di_userSuffix = Stream(this.userInfoOriginalData.userSuffix());
      this.settings.u2di_jjType = Stream(this.userInfoOriginalData.jjType());
      this.settings.u2di_jjTypeValue = Stream(this.userInfoOriginalData.jjTypeValue());
      this.settings.u2di_userID = this.userData.id();
      this.settings.u2di_userType = Stream(this.userInfoOriginalData.userType());
      this.settings.u2di_userStatus = Stream(this.userInfoOriginalData.userStatus());
      this.settings.u2di_expireDays = Stream(this.userInfoOriginalData.expireDays());
      this.settings.u2di_noExpiration = Stream(this.userInfoOriginalData.noExpiration());
      this.settings.u2di_bmqy = Stream(this.userInfoOriginalData.bmqy());
      this.settings.u2di_zjgw = Stream(this.userInfoOriginalData.zjgw());
      this.settings.u2di_zsxm = Stream(this.userInfoOriginalData.zsxm());
      this.settings.u2di_zsxm_title = Stream(this.userInfoOriginalData.zsxm_title());
      this.settings.u2di_lxdh = Stream(CryptoJSAesJson.decrypt(this.userInfoOriginalData.lxdh(), this.userKey));
      this.settings.u2di_lxdh_wx = Stream(CryptoJSAesJson.decrypt(this.userInfoOriginalData.lxdh_wx(), this.userKey));
      this.settings.u2di_lxdh_wx_checked = Stream(this.userInfoOriginalData.lxdh()===this.userInfoOriginalData.lxdh_wx());
      this.settings.u2di_lxdh_wx_qr = Stream(JSON.parse(lxdh_wx_qr));
      this.settings.u2di_khh = Stream(CryptoJSAesJson.decrypt(this.userInfoOriginalData.khh(), this.userKey));
      this.settings.u2di_yhkh = Stream(CryptoJSAesJson.decrypt(this.userInfoOriginalData.yhkh(), this.userKey));
      this.settings.u2di_sfzh = Stream(CryptoJSAesJson.decrypt(this.userInfoOriginalData.sfzh(), this.userKey));
    }

  }

  onready(){
    const _this = this;

    $('.u2diSubmitModalBody input[type=checkbox]').on('click', function() {
      _this.modified = true;
    });

    $('.u2diSubmitModalBody input[type=text]').on('input', function() {
      _this.modified = true;
    });

    $('input[type=radio][name=option_userTitle]').on('change', function() {
      let value = parseInt($(this).val());
      _this.settings.u2di_zsxm_title(value);
      _this.modified = true;
      m.redraw();
    });

    $('input[type=radio][name=option_jj_type]').on('change', function() {
      let value = parseInt($(this).val());
      _this.settings.u2di_jjType(value);
      _this.modified = true;

      if(value===0){
        _this.settings.u2di_jjTypeValue("");
      }
      m.redraw();
    });

    $("#u2di_user_banned").change(function() {
      const value = this.checked;
      let userStatus = 0;

      if(value===true){
        userStatus = 2;
      }else{
        if(_this.settings.u2di_expireDays()===0 && _this.settings.u2di_noExpiration()===0){
          userStatus = 1;
        }
      }

      _this.settings.u2di_userStatus(userStatus);
      m.redraw();
    }); 

    $("#u2di_user_signed").change(function() {
      const value = this.checked;
      let userStatus = value===true?1:0;

      _this.settings.u2di_userSigned(userStatus);
      m.redraw();
    }); 

    $("#u2di_no_expiration").change(function() {
      const value = this.checked;
      let userInfo = getUserInfo(_this.userData.id());
      let userStatus = _this.settings.u2di_userStatus();

      if(userStatus!==2 && _this.settings.u2di_expireDays()===0 && userInfo.userType()!==9){
        userStatus = value===false?1:0;
      }

      _this.settings.u2di_userStatus(userStatus);
      _this.settings.u2di_noExpiration(value?1:0);
      m.redraw();
    }); 

    $("#u2di_lxdh_wx_checked").change(function() {
      _this.settings.u2di_lxdh_wx_checked(this.checked);

      if(this.checked){
        _this.settings.u2di_lxdh_wx(_this.settings.u2di_lxdh());
      }else{
        _this.settings.u2di_lxdh_wx("");
      }

      m.redraw();
    }); 
  }

  className() {
    return 'Modal--medium';
  }

  title() {
    let userInfo = getUserInfo(this.userData.id());
    const userSuffix = userInfo.userSuffix();
    let title = this.userEditFrom==="admin"?app.translator.trans('ziven-u2di.forum.title-user-information'):app.translator.trans('ziven-u2di.forum.title-user-account');
    let userType = userSuffix?app.translator.trans('ziven-u2di.forum.user-type-suffix'):app.translator.trans('ziven-u2di.forum.user-type-'+userInfo.userType());

    return (
      <div style="position: relative;">
        {title} <span style='font-size:12px'>（{userType}）</span>
      </div>
    );
  }

  content() {
    const _this = this;
    const settings = this.settings;
    const editMode = this.editMode;
    const user = this.userData;
    const userInfoData = this.userInfoData;
    const inviteCodeHistory = userInfoData.u2diInviteCodeData();
    const userStatus = userInfoData.userStatus();
    const inviteCode = userInfoData.inviteCode();
    const currentDate = userInfoData.currentDate();
    const expireDays = userInfoData.expireDays();
    const expireDate = dayjs(addDaysToDate(currentDate,expireDays)).format('YYYY年M月D日');
    const username = user.username();
    const joinTime = dayjs(user.joinTime()).format('LLL')
    const statusSetting = getStatusSetting(userStatus);
    const userStatusText = app.translator.trans('ziven-u2di.forum.user-status-'+userStatus);
    const statusColor = statusSetting.statusColor;
    const userStatusStyle = statusSetting.statusStyle;

    const u2diUserType0 = app.forum.attribute('u2diUserType0');
    const u2diUserType9 = app.forum.attribute('u2diUserType9');

    return (
      <div className="Modal-body u2diSubmitModalBody">
        <div style="text-align:center;position:relative">
          <div>UID: {this.settings.u2di_userID}</div>
          <div style={userStatusStyle} className="u2diUserManagementColumnRoundedItem">{userStatusText}</div>
          {this.editMode===false && (
            <span>
              {Button.component({
                  style:"position: absolute;width: 50px;font-size: 12px;height: 24px;line-height: 0px;right: 60px;top: 2px;padding-left: 13px;",
                  disabled: this.loading,
                  className: 'Button U2DiButton--gray',
                  onclick: (e) => {
                    this.editMode = true;
                  }
                },
                app.translator.trans('ziven-u2di.lib.edit')
              )}
            </span>
          )}
          {this.userEditFrom==="admin" && (
            <span>
              {Button.component({
                  style:"position: absolute;width: 50px;font-size: 12px;height: 24px;line-height: 0px;right: 0px;top: 2px;padding-left: 13px;",
                  disabled: this.loading,
                  className: 'Button U2DiButton--gray',
                  onclick: (e) => {
                    this.requestUserSummary();
                  }
                },
                app.translator.trans('ziven-u2di.forum.user-summary')
              )}
            </span>
          )}
        </div>

        <div className="Form-group">
          {this.userEditFrom==="admin" && (
            <div className="u2diSignUpCategoryTitle Form-group">
              {app.translator.trans('ziven-u2di.forum.signup-category-zhgl')}
            </div>
          )}

          {this.userEditFrom==="admin" && (
            <div className="u2diUserSubmitCategoryItems" style="text-align: left;align-items: baseline;">
              <div className="u2diUserSubmitCategoryItemName u2diSignUpItemName" style="display: flex;align-items: center;">
                <input disabled={this.loading || this.editMode===false}  id="u2di_user_banned" className="u2diUserSubmitCategoryItemRadioNoMargin" type="checkbox" value="0" checked={this.settings.u2di_userStatus()==2?"checked":""} /><label style="margin-left: 5px;" for="u2di_user_banned">{app.translator.trans('ziven-u2di.forum.signup-field-user-status-banned')}</label>
              </div>
              <div className="u2diUserSubmitCategoryItemOptions u2diSignUpItemOptions">
                <div style="font-size: 12px;color: gray;height: 30px;">
                  {app.translator.trans('ziven-u2di.forum.signup-field-user-status-banned-hint')}
                </div>
              </div>
            </div>
          )}

          {this.userEditFrom==="admin" && (
            <div>
              <div className="u2diUserSubmitCategoryItems" style="text-align: left;align-items: baseline;">
                <div className="u2diUserSubmitCategoryItemName u2diSignUpItemName" style="display: flex;align-items: center;">
                  <input disabled={this.loading || this.editMode===false}  id="u2di_user_signed" className="u2diUserSubmitCategoryItemRadioNoMargin" type="checkbox" value="0" checked={this.settings.u2di_userSigned()==1?"checked":""} />
                  <label style="margin-left: 5px;" for="u2di_user_signed">{app.translator.trans('ziven-u2di.forum.signup-field-user-signed')}</label>
                </div>
                <div className="u2diUserSubmitCategoryItemOptions u2diSignUpItemOptions">
                </div>
              </div>
              <div className="u2diUserSubmitCategoryItems" style="text-align: left;padding-top: 10px;">
                <div className="u2diUserSubmitCategoryItemNameMargin u2diUserSubmitCategoryItemName u2diSignUpItemName">
                  {app.translator.trans('ziven-u2di.forum.signup-field-jj-type')}
                </div>
                <div className="u2diUserSubmitCategoryItemOptions u2diSignUpItemOptions">
                  <div style="display: flex;height: 40px;align-items: center;">
                    <div>
                      <input disabled={this.loading || this.editMode===false} id="jjType1" type="radio" name="option_jj_type" value="0" checked={this.settings.u2di_jjType()==0?"checked":""} />
                      <label style="margin-left: 5px;" for="jjType1">{app.translator.trans('ziven-u2di.forum.signup-field-jj-type-0')}</label>
                    </div>
                    <div style="margin-left:10px">
                      <input disabled={this.loading || this.editMode===false} id="jjType2" type="radio" name="option_jj_type" value="1" checked={this.settings.u2di_jjType()==1?"checked":""} />
                      <label style="margin-left: 5px;" for="jjType2">{app.translator.trans('ziven-u2di.forum.signup-field-jj-type-1')}</label></div>
                      <input disabled={this.loading || this.editMode===false || this.settings.u2di_jjType()!=1} type="number" className="FormControl u2diUserJJType" bidi={this.settings.u2di_jjTypeValue} />&nbsp;%
                  </div>
                </div>
              </div>

              <div className="u2diUserSubmitCategoryItems" style="text-align: left;padding-top: 10px;">
                <div className="u2diUserSubmitCategoryItemNameMargin u2diUserSubmitCategoryItemName u2diSignUpItemName">
                  {app.translator.trans('ziven-u2di.forum.signup-field-suffix')}
                </div>
                <div className="u2diUserSubmitCategoryItemOptions u2diSignUpItemOptions">
                  <input style="width: 100px;" disabled={this.loading || this.editMode===false} required type="text" className="FormControl" bidi={this.settings.u2di_userSuffix} />
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="Form-group">
          <div className="u2diSignUpCategoryTitle Form-group">
            {app.translator.trans('ziven-u2di.forum.signup-category-zhxx')}
          </div>

          <div className="u2diUserSubmitCategoryItems" style="text-align: left;">
            <div className="u2diUserSubmitCategoryItemName u2diSignUpItemName">
              {app.translator.trans('ziven-u2di.forum.signup-field-avatar')}
            </div>
            <div className="u2diUserSubmitCategoryItemOptions u2diSignUpItemOptions">
              {this.editMode===true && (
                AvatarEditor.component({ user, className: 'UserCard-avatar u2diAvatarEditor'})
              )}

              {this.editMode===false && (
                <div style="display: flex;align-items: flex-end;">
                  {avatar(this.userData)}
                  {this.editMode===true && (
                    <a style="margin-left: 10px;" onclick={(e) => this.deleteAvatar()}>
                      {app.translator.trans('ziven-u2di.forum.item-delete-avatar')}
                    </a>
                  )}
                </div>
              )}
            </div>
          </div>

          {this.userEditFrom==="admin" && (
            <div className="u2diUserSubmitCategoryItems" style="text-align: left;padding-top: 10px;">
              <div className="u2diUserSubmitCategoryItemName u2diSignUpItemName">
                {app.translator.trans('ziven-u2di.forum.signup-field-user-type')}
              </div>
              <div className="u2diUserSubmitCategoryItemOptions u2diSignUpItemOptions">
                <Select disabled={this.loading || this.editMode===false} className="u2diDataSelectList" value={this.settings.u2di_userType()}
                  options={{
                    "0":app.translator.trans('ziven-u2di.forum.user-type-0'),
                    "9":app.translator.trans('ziven-u2di.forum.user-type-9'),
                  }}
                  onchange={(e) => {
                    this.settings.u2di_userType(e);
                    // this.modified = true;
                  }}
                />
              </div>
            </div>
          )}

          <div className="u2diUserSubmitCategoryItems" style="text-align: left;padding-top: 10px;">
            <div className="u2diUserSubmitCategoryItemName u2diSignUpItemName">
              {app.translator.trans('ziven-u2di.forum.signup-field-username')}
            </div>
            <div className="u2diUserSubmitCategoryItemOptions u2diSignUpItemOptions">
              {username}
            </div>
          </div>

          <div className="u2diUserSubmitCategoryItems" style="text-align: left;padding-top: 10px;">
            <div className="u2diUserSubmitCategoryItemName u2diSignUpItemName">
              {app.translator.trans('ziven-u2di.forum.signup-field-email')}
            </div>
            <div className="u2diUserSubmitCategoryItemOptions u2diSignUpItemOptions">
              <input disabled={this.loading || this.editMode===false} required type="text" className="FormControl" bidi={this.settings.u2di_userEmail} placeholder={app.translator.trans('ziven-u2di.lib.required')} />
            </div>
          </div>

          <div className="u2diUserSubmitCategoryItems" style="text-align: left;padding-top: 10px;">
            <div className="u2diUserSubmitCategoryItemName u2diSignUpItemName">
              {app.translator.trans('ziven-u2di.forum.signup-field-password-reset')}
            </div>
            <div className="u2diUserSubmitCategoryItemOptions u2diSignUpItemOptions">
              <input disabled={this.loading || this.editMode===false} type="password" className="FormControl" bidi={this.settings.u2di_userPassword} placeholder={app.translator.trans('ziven-u2di.forum.signup-field-password-reset-placehold')} />
            </div>
          </div>

          <div className="u2diUserSubmitCategoryItems" style="text-align: left;padding-top: 10px;">
            <div className="u2diUserSubmitCategoryItemName u2diSignUpItemName">
              {app.translator.trans('ziven-u2di.forum.signup-field-register-date')}
            </div>
            <div className="u2diUserSubmitCategoryItemOptions u2diSignUpItemOptions">
              {joinTime}
            </div>
          </div>

          <div className="u2diUserSubmitCategoryItems" style="text-align: left;padding-top: 10px;">
            <div className="u2diUserSubmitCategoryItemName u2diSignUpItemName">
              {app.translator.trans('ziven-u2di.forum.signup-field-register-invite-code')}
            </div>
            <div className="u2diUserSubmitCategoryItemOptions u2diSignUpItemOptions">
              {inviteCode===""?app.translator.trans('ziven-u2di.lib.none'):inviteCode}
            </div>
          </div>

          <div className="u2diUserSubmitCategoryItems" style="text-align: left;padding-top: 10px;align-items: baseline;">
            <div className="u2diUserSubmitCategoryItemName u2diSignUpItemName">
              {app.translator.trans('ziven-u2di.forum.signup-field-valid-date')}
            </div>
            <div style={this.userEditFrom==="admin"?"":"display: flex;align-items: center;"} className="u2diUserSubmitCategoryItemOptions u2diSignUpItemOptions">
              {this.settings.u2di_noExpiration()===1 && (
                <div>{app.translator.trans('ziven-u2di.forum.item-user-duration-unlimit')}</div>
              )}

              {this.settings.u2di_noExpiration()===0 && (
                <div>{expireDate} <span style="font-size:12px">{app.translator.trans('ziven-u2di.forum.item-days-left',{expireDays:expireDays})}</span></div>
              )}

              {this.userEditFrom==="admin" && (
                <div style="display:flex;padding-top: 10px;"><input disabled={this.loading || this.editMode===false} id="u2di_no_expiration" className="u2diUserSubmitCategoryItemRadioNoMargin" type="checkbox" value="0" checked={this.settings.u2di_noExpiration()==1?"checked":""} /><label style="margin-left: 5px;" for="u2di_no_expiration">{app.translator.trans('ziven-u2di.forum.signup-field-no-expiration')}</label></div>
              )}

              {this.userEditFrom==="user" && (
                <div style="margin-left: 10px;">
                  {Button.component({
                      style:"width: 40px;font-size: 12px;height: 24px;line-height: 0px;padding-left: 10px;padding-left: 8.5px;",
                      disabled: this.loading,
                      className: 'Button Button--primary',
                      onclick: (e) => {
                        app.modal.show(UserApplyInviteCodeModal,{userInfoData,editMode,settings});
                      }
                    },
                    app.translator.trans('ziven-u2di.forum.button-extend_expiration')
                  )}
                </div>
              )}

            </div>
          </div>

          <div className="u2diUserSubmitCategoryItems" style="text-align: left;padding-top: 10px;align-items: baseline;">
            <div className="u2diUserSubmitCategoryItemName u2diSignUpItemName">
              {app.translator.trans('ziven-u2di.forum.signup-field-invite-code-history')}
            </div>
            <div className="u2diUserSubmitCategoryItemOptions u2diSignUpItemOptions" style="max-height: 130px;overflow-y: auto;">
              {inviteCodeHistory.map((inviteCodeData) => {
                const inviteCodeItem = inviteCodeData.inviteCode();
                const isManual = inviteCodeItem.indexOf('manual')!==-1;

                return (
                  <div className="u2diInviteCodeHistoryContainer">
                    <div>{isManual?app.translator.trans('ziven-u2di.forum.item-invite-code-history-'+inviteCodeItem):inviteCodeItem}</div>
                    <div style="text-align: center;">{app.translator.trans('ziven-u2di.forum.item-invite-code-type-'+inviteCodeData.codeType())}</div>
                    <div style="text-align: center;">{app.translator.trans('ziven-u2di.forum.item-invite-code-duration-'+inviteCodeData.validDuration())}</div>
                  </div>
                );
              })}
            </div>
          </div>

        </div>

        <div className="Form-group">
          <div className="u2diSignUpCategoryTitle Form-group">
            {app.translator.trans('ziven-u2di.forum.signup-category-yhxx')}
          </div>
          <div className="Form-group" style="display:none !important;display: grid;grid-template-columns: repeat(3, 1fr);">
            <div><input disabled={this.loading || this.editMode===false} id="userType0" type="radio" name="option_userType" value="0" checked={this.settings.u2di_userType()==0?"checked":""} /><label style="margin-left: 5px;" for="userType0">{app.translator.trans('ziven-u2di.forum.signup-field-user-type-0')}</label></div>
            <div><input disabled={this.loading || this.editMode===false} id="userType1" type="radio" name="option_userType" value="1" checked={this.settings.u2di_userType()==1?"checked":""} /><label style="margin-left: 5px;" for="userType1">{app.translator.trans('ziven-u2di.forum.signup-field-user-type-1')}</label></div>
            <div><input disabled={this.loading || this.editMode===false} id="userType2" type="radio" name="option_userType" value="2" checked={this.settings.u2di_userType()==2?"checked":""} /><label style="margin-left: 5px;" for="userType2">{app.translator.trans('ziven-u2di.forum.signup-field-user-type-2')}</label></div>
          </div>

          <div className="u2diUserSubmitCategoryItems" style="text-align: left;">
            <div className="u2diUserSubmitCategoryItemName u2diSignUpItemName">
              {app.translator.trans('ziven-u2di.forum.signup-field-bmqy')}
            </div>
            <div className="u2diUserSubmitCategoryItemOptions u2diSignUpItemOptions">
              <input disabled={this.loading || this.editMode===false} required type="text" className="FormControl" bidi={this.settings.u2di_bmqy}  placeholder={app.translator.trans('ziven-u2di.lib.optional')} />
            </div>
          </div>

          <div className="u2diUserSubmitCategoryItems" style="text-align: left;">
            <div className="u2diUserSubmitCategoryItemName u2diSignUpItemName">
              {app.translator.trans('ziven-u2di.forum.signup-field-zjgw')}
            </div>
            <div className="u2diUserSubmitCategoryItemOptions u2diSignUpItemOptions">
              <input disabled={this.loading || this.editMode===false} required type="text" className="FormControl" bidi={this.settings.u2di_zjgw}  placeholder={app.translator.trans('ziven-u2di.lib.optional')} />
            </div>
          </div>

          <div className="u2diUserSubmitCategoryItems" style="text-align: left;">
            <div className="u2diUserSubmitCategoryItemName u2diSignUpItemName">
              {app.translator.trans('ziven-u2di.forum.signup-field-zsxm')}
            </div>
            <div className="u2diUserSubmitCategoryItemOptions u2diSignUpItemOptions">
              <div style="display: flex;height: 40px;align-items: center;">
                {u2diUserType9===true && (
                  <div style="padding-right: 10px;">
                    <input style="width: 100px;" disabled={this.loading || this.editMode===false} required type="text" className="FormControl" bidi={this.settings.u2di_zsxm}  placeholder={app.translator.trans('ziven-u2di.lib.required')} />
                  </div>
                )}

                {u2diUserType9===false && u2diUserType0===true && (
                  <div style="padding-right: 10px;">{this.settings.u2di_zsxm()}</div>
                )}
                <div><input disabled={this.loading || this.editMode===false} id="userTitle1" type="radio" name="option_userTitle" value="0" checked={this.settings.u2di_zsxm_title()==0?"checked":""} /><label style="margin-left: 5px;" for="userTitle1">{app.translator.trans('ziven-u2di.forum.signup-field-user-zsxm-title-0')}</label></div>
                <div style="margin-left:10px"><input disabled={this.loading || this.editMode===false} id="userTitle2" type="radio" name="option_userTitle" value="1" checked={this.settings.u2di_zsxm_title()==1?"checked":""} /><label style="margin-left: 5px;" for="userTitle2">{app.translator.trans('ziven-u2di.forum.signup-field-user-zsxm-title-1')}</label></div>
              </div>
            </div>
          </div>

          <div className="u2diUserSubmitCategoryItems" style="text-align: left;">
            <div className="u2diUserSubmitCategoryItemName u2diSignUpItemName">
              {app.translator.trans('ziven-u2di.forum.signup-field-lxdh')}
            </div>
            <div className="u2diUserSubmitCategoryItemOptions u2diSignUpItemOptions">
              <input maxlength="11" disabled={this.loading || this.editMode===false} required type="text" className="FormControl" bidi={this.settings.u2di_lxdh}  placeholder={app.translator.trans('ziven-u2di.lib.required')} />
            </div>
          </div>

          <div className="u2diUserSubmitCategoryItems" style="text-align: left;">
            <div className="u2diUserSubmitCategoryItemName u2diSignUpItemName">
              
            </div>
            <div className="u2diUserSubmitCategoryItemOptions u2diSignUpItemOptions">
              <div style="display: flex;height: 40px;align-items: center;">
                <input disabled={this.loading || this.editMode===false} style="margin-left:0px" id="u2di_lxdh_wx_checked" className="u2diUserSubmitCategoryItemRadio" type="checkbox" value="0" checked={this.settings.u2di_lxdh_wx_checked()==1?"checked":""} /><label style="margin-left: 5px;" for="u2di_lxdh_wx_checked">{app.translator.trans('ziven-u2di.forum.signup-field-lxdh-wx-checked')}</label>
              </div>
            </div>
          </div>

          <div className="u2diUserSubmitCategoryItems" style="text-align: left;">
            <div className="u2diUserSubmitCategoryItemName u2diSignUpItemName">
              {app.translator.trans('ziven-u2di.forum.signup-field-lxdh-wx')}
            </div>
            <div className="u2diUserSubmitCategoryItemOptions u2diSignUpItemOptions">
              <input maxlength="11" disabled={this.loading || this.editMode===false || this.settings.u2di_lxdh_wx_checked()} required type="text" className="FormControl" bidi={this.settings.u2di_lxdh_wx_checked()?this.settings.u2di_lxdh:this.settings.u2di_lxdh_wx}  placeholder={app.translator.trans('ziven-u2di.lib.required')} />
            </div>
          </div>
        </div>

        <div className="Form-group">
          <div className="u2diSignUpCategoryTitle Form-group">
            {app.translator.trans('ziven-u2di.forum.signup-category-ykxx')}
          </div>
          
          <div className="u2diUserSubmitCategoryItems" style={this.editMode===false?"text-align: left;align-items: flex-start;":"text-align: left;align-items: baseline;"}>
            <div style="margin-top: -10px;" className="u2diUserSubmitCategoryItemName u2diSignUpItemName">
              {app.translator.trans('ziven-u2di.forum.signup-field-lxdh-wx-qr')}
            </div>
            <div className="u2diUserSubmitCategoryItemOptions u2diSignUpItemOptions">
              <UploadComponent uploadType="wxewm" uploadLimit="1" viewType={this.editMode===true?"edit":"read"} uploadTarget={this.settings.u2di_lxdh_wx_qr} uploadCallback={function(result,option_target){
                _this.settings.u2di_lxdh_wx_qr = option_target;
              }} />
            </div>
          </div>

          <div className="u2diUserSubmitCategoryItems" style="text-align: left;">
            <div className="u2diUserSubmitCategoryItemName u2diSignUpItemName">
              {app.translator.trans('ziven-u2di.forum.signup-field-khh')}
            </div>
            <div className="u2diUserSubmitCategoryItemOptions u2diSignUpItemOptions">
              <input disabled={this.loading || this.editMode===false || u2diUserType9===false} required type="text" className="FormControl" bidi={this.settings.u2di_khh}  placeholder={app.translator.trans('ziven-u2di.lib.required')} />
            </div>
          </div>

          <div className="u2diUserSubmitCategoryItems" style="text-align: left;">
            <div className="u2diUserSubmitCategoryItemName u2diSignUpItemName">
              {app.translator.trans('ziven-u2di.forum.signup-field-yhkk')}
            </div>
            <div className="u2diUserSubmitCategoryItemOptions u2diSignUpItemOptions">
              <input disabled={this.loading || this.editMode===false || u2diUserType9===false} required type="text" className="FormControl" bidi={this.settings.u2di_yhkh} placeholder={app.translator.trans('ziven-u2di.lib.required')} />
            </div>
          </div>

          <div className="u2diUserSubmitCategoryItems" style="text-align: left;">
            <div className="u2diUserSubmitCategoryItemName u2diSignUpItemName">
              {app.translator.trans('ziven-u2di.forum.signup-field-sfzh')}
            </div>
            <div className="u2diUserSubmitCategoryItemOptions u2diSignUpItemOptions">
              <input disabled={this.loading || this.editMode===false || u2diUserType9===false} required type="text" className="FormControl" bidi={this.settings.u2di_sfzh}  placeholder={app.translator.trans('ziven-u2di.lib.required')} />
            </div>
          </div>
        </div>
        {this.editMode===true && (
          <div style="text-align: center;">
            {Button.component({
                style:"min-width:66px;",
                disabled: this.loading,
                type: 'submit',
                className: 'Button Button--primary',
                onclick: (e) => {
                  this.editData(e);
                }
              },
              app.translator.trans('ziven-u2di.lib.save')
            )}
            &nbsp;
            {Button.component({
                style:"min-width:66px;",
                className: 'Button U2DiButton--gray',
                disabled: this.loading,
                onclick: () => {
                  this.editMode = false;
                  this.resetData = true;
                  m.redraw();
                }
              },
              app.translator.trans('ziven-u2di.lib.cancel')
            )}
          </div>
        )}
      </div>
    );
  }

  deleteAvatar() {
    this.settings.u2di_userAvatar(null);
    // this.modified = true;
    m.redraw();
  }

  requestUserSummary(){
    this.loading = true;
    app.request({
      url: `${app.forum.attribute('apiUrl')}/u2diUserSummary`,
      method: 'POST',
      body:{userID:this.settings.u2di_userID}
    }).then(response => {
      this.loading = false;
      showAlert(app.translator.trans('ziven-u2di.forum.success-user-summary'),'success');
      }, error => {
        this.loading = false;
        throw error;
      });
  }

  editData(e) {
    e.preventDefault();

    this.loading = true;
    this.userInfoData.save({
      userPassword: this.settings.u2di_userPassword(),
      userAvatar: this.settings.u2di_userAvatar(),
      userEmail: this.settings.u2di_userEmail(),
      userSuffix: this.settings.u2di_userSuffix(),
      jjType: this.settings.u2di_jjType(),
      jjTypeValue: this.settings.u2di_jjTypeValue(),
      userType: this.settings.u2di_userType(),
      userStatus: this.settings.u2di_userStatus(),
      userSigned: this.settings.u2di_userSigned(),
      bmqy: this.settings.u2di_bmqy(),
      zjgw: this.settings.u2di_zjgw(),
      zsxm: this.settings.u2di_zsxm(),
      zsxm_title: this.settings.u2di_zsxm_title(),
      lxdh: this.settings.u2di_lxdh(),
      lxdh_wx: this.settings.u2di_lxdh_wx(),
      lxdh_wx_qr: JSON.stringify(this.settings.u2di_lxdh_wx_qr()),
      khh: this.settings.u2di_khh(),
      yhkh: this.settings.u2di_yhkh(),
      sfzh: this.settings.u2di_sfzh(),
      noExpiration: this.settings.u2di_noExpiration(),
    })
    .then(() => {
        this.loading = false;
        this.editMode = false;
        // this.modified = false;
        showAlert(app.translator.trans('ziven-u2di.forum.success-save'),'success');
        m.redraw();
      },
      (response) => {
        this.loading = false;
      }
    );
  }
}
